module.exports = __webpack_public_path__ + "static/2-3a7c20322745e546dea49ffe4cfbef15.png";